import classNames from "classnames";
import { MutableRefObject, useEffect, useState } from "react";
import "sass/components/IndexScroll.scss";

type IndexScrollProps = {
  sectionTitles: string[];
  sectionRefs: MutableRefObject<null[] | HTMLElement[]>;
};

function IndexScroll({ sectionTitles, sectionRefs }: IndexScrollProps) {
  const [activeSection, setActiveSection] = useState(0);
  const [lastActiveIndex, setLastActiveIndex] = useState(0);
  const [onScrolling, setOnScolling] = useState(false);

  const scrollToSection = (index: number) => {
    setActiveSection(index);
    setLastActiveIndex(index);
    setOnScolling(true);
    sectionRefs.current[index]?.scrollIntoView({ behavior: "smooth" });
    setTimeout(() => {
      setOnScolling(false);
    }, 300);
  };

  useEffect(() => {
    if (onScrolling) {
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (sectionRefs.current === null) {
        }
        const refs: HTMLElement[] = sectionRefs.current as HTMLElement[];
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.1) {
            const index = refs!.indexOf(entry.target as HTMLElement);
            console.log();
            setActiveSection(index);
            setLastActiveIndex(index);
          }
        });
      },
      {
        root: null, // using viewport as the root
        rootMargin: "0px",
        threshold: 0.5, // 50% of the item must be visible
      }
    );

    sectionRefs.current.forEach((section) => {
      if (section) observer.observe(section);
    });

    return () => {
      if (sectionRefs === null) {
        return;
      }
      sectionRefs!.current.forEach((section) => {
        if (section) observer.unobserve(section);
      });
    };
  }, []);

  // Function to determine the most visible section on the viewport
  // const handleScroll = () => {
  //   if (onScrolling) {
  //     return;
  //   }
  //   const sectionHeights = sectionRefs.current.map((ref) => {
  //     if (ref) {
  //       const rect = ref.getBoundingClientRect();
  //       return {
  //         top: rect.top,
  //         bottom: rect.bottom,
  //       };
  //     }
  //     return null;
  //   });

  //   if (sectionHeights !== null) {
  //     // find visible section on the top of viewport
  //     console.log(sectionHeights[1]?.top + ":" + sectionHeights[0]?.bottom);

  //     const visibleSection = sectionHeights.findIndex((s) => {
  //       const relativeTop = Math.abs(s!.top);
  //       const windowHeight = window.innerHeight;
  //       // return relativeTop < windowHeight / 2 && s!.bottom > windowHeight / 2;
  //     });

  //     if (visibleSection !== -1 && visibleSection !== activeSection) {
  //       setActiveSection(visibleSection);
  //       setLastActiveIndex(visibleSection);
  //     }
  //   }
  // };

  // useEffect(() => {
  //   window.addEventListener("scroll", handleScroll, { passive: true });
  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // });

  return (
    <div className="index-scroll-container">
      <div className="index-scroll-box">
        <div className="index-scroll-bar" />
        <div className="index-scroll-indicator-container">
          {sectionTitles.map((title, index) => (
            <div
              className={classNames("indicator-container", {
                active: index === activeSection,
              })}
              onClick={() => scrollToSection(index)}
              onMouseEnter={() => setActiveSection(index)}
              onMouseLeave={() => setActiveSection(lastActiveIndex)}
              key={index}
            >
              <div>{title}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default IndexScroll;
